export default function logOut(){
        // ulozeni dashboardu - predevsim kvuli razeni sloupcu
        if (this.dataGet("conf/view") === "home") {
                this.homeLayoutSave();
        }

        this.routeLogin()
}